export enum status {
  SUCCESS = "success",
  WARNING = "warning",
  ERROR = "error",
}

export enum ProfileStatus {
  Active = "Active",
  Deactivated = "Deactivated",
  SubscriptionExpired = "SubscriptionExpired",
}

export enum ActionType {
  UPGRADE = "upgrade",
  DOWNGRADE = "downgrade",
}

export enum SubscriptionCategory {
  FREE = "Free",
  INDIE = "Indie",
  STUDIO = "Studio",
}

export enum SubscriptionType {
  FREE = "Free Plan",
  INDIE = "Indie Plan",
  STUDIO = "Studio Plan",
}

export enum DefaultLimits {
  ADDONS = 10,
}

export enum SubscriptionStatus {
  ACTIVE = "active",
  PAUSED = "paused",
  CANCELED = "canceled",
  INCOMPLETE = "incomplete",
  INCOMPLETE_EXPIRED = "incomplete_expired",
  PAST_DUE = "past_due",
  TRIALING = "trialing",
  UNPAID = "unpaid",
}

export enum linkType {
  INTERNAL = "internal",
  EXTERNAL = "external",
}

export enum InvitationStatus {
  ACCEPTED = "accepted",
  PENDING = "pending",
}

export enum PaymentStatus {
  CREATE_PLAN_SUBSCRIPTION = "pricing-plan",
  UPGRADE_PLAN_SUBSCRIPTION = "upgrade-pricing-plan",
  DOWNGRADE_PLAN_SUBSCRIPTION = "downgrade-pricing-plan",
  CANCEL_DOWNGRADE_PLAN_SUBSCRIPTION = "cancel-downgrade-pricing-plan",

  UPGRADE_SEATS_SUBSCRIPTION = "upgrade-seats",
  DOWNGRADE_SEATS_SUBSCRIPTION = "downgrade-seats",

  UPGRADE_PROJECTS_SUBSCRIPTION = "upgrade-projects",
  DOWNGRADE_PROJECTS_SUBSCRIPTION = "downgrade-projects",

  CREATE_PROJECT_PURCHASE = "create-project",
}

// WeekDay numbers are dependant on luxon library used on BE.
// See https://moment.github.io/luxon/api-docs/index.html#datetimeweekday
// 1 is Monday and 7 is Sunday. Please do not change until BE is changed as well.
export enum WeekDay {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 7,
}

export enum CheckboxColor {
  Gray = "border-border",
  Yellow = "border-primary",
}
